import { render, staticRenderFns } from "./ImgRankin.vue?vue&type=template&id=366ba52f"
import script from "./ImgRankin.vue?vue&type=script&lang=js"
export * from "./ImgRankin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports